import { TabStrip } from "../core/components/tabStrip.js";
import { Config } from "../core/config/config.js";
import React from "react";
export default class MachineSkills extends React.Component<any, any> {
    private _metaData = {
        tabs: [],
        additional: {
            objects: []
        }
    };

    constructor(props) {
        super(props)
        this._initApp();
    }

    private _updateTitle = () => {
        let pos = -1;
        if (Config.user.skills.zuMaschine) {
            pos++;
        }
        if (Config.user.skills.zuMaschinenTyp) {
            pos++;
            this._metaData.tabs[pos].props.title = this.props.translations["WebSMS.Machine.MachineType"] + ": " + this.props.entity.Maschtyp
        }
    }

    private _initApp = () => {
        if (Config.user.skills.zuMaschine) {
            this._metaData.tabs.push({
                title: this.props.translations["WebSMS.UserSettings.Skills.MachineSkills"],
                component: "createSkillsMachine()",
                props: {
                    title: ""
                }
            });
        }
        if (Config.user.skills.zuMaschinenTyp) {
            this._metaData.tabs.push({
                title: this.props.translations["WebSMS.UserSettings.Skills.MachineTypeSkills"],
                component: "createSkillsMachineType()",
                props: {
                    title: ""
                }
            });
            this._updateTitle();
        }
    }

    componentDidUpdate() {
        this._updateTitle();
    }

    render() {
        return (
            <div className="flex-container__item flex-container">
                <TabStrip metadata={this._metaData} entity={this.props.entity} dataSources={{}} horizontal={true}
                    context={this.props.context} onChange={this.props.onChange} onDataLoaded={null}
                    handleEval={this.props.handleEval} handleIsSearchFieldFullObjectModel={null}
                    handleIndividulFieldsMetaDataCreated={null}
                    commandManager={this.props.commandManager} translations={this.props.translations} />
            </div>
        );
    }
}